import React, { Component } from 'react';
import { Modal, Button } from 'antd';


class AddressInfo extends Component {
    state = {
        visible: false,
        record: {},
    }

    show = (record) => {
        this.setState({
            visible: true,
            record,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            record: {},
        });
    }

    render() {
        const { visible, record } = this.state;
        const { compName, addressList = '' } = record;
        const addressData = addressList.split(',');
        return (
            <Modal
                title="地址"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="550px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div style={{ padding: '30px 40px' }}>
                    <div style={{ marginBottom: 10 }}>机构名称：{compName}</div>
                    {
                        addressData.map(el => <div
                                style={{ marginBottom: 10 }}
                            > 
                            其他机构地址：{el}
                            </div>
                        )
                    }
                </div>
            </Modal>
        )
    }
}

export default AddressInfo;


// WEBPACK FOOTER //
// ./src/components/hospital/filingInfo/components/AddressInfo.js